
import colors from 'shared/colors';

const caps = {
  textTransform: 'uppercase',
  letterSpacing: '.2em',
};

const monospace = '"Roboto Mono", Menlo, Consolas, monospace';

const baseColors = {
  black: '#111',
  white: '#fff',
  gray: '#ddd',
  midgray: '#888',
  blue: '#08e',
  red: '#f52',
  orange: '#f70',
  green: '#1c7',
};

const defaultColors = {
  ...baseColors,
  primary: baseColors.blue,
  secondary: baseColors.midgray,
  default: baseColors.black,
  info: baseColors.blue,
  success: baseColors.green,
  warning: baseColors.orange,
  error: baseColors.red,
};

const fontSizes = [
  48,
  32,
  24,
  20,
  16,
  14,
  12,
];

const config = {
  fontFamily: '"Avenir Next", Lato, Helvetica, sans-serif',
  color: '#eee',
  bold: 700,
  backgroundColor: '#111',
  borderRadius: 5,
  borderColor: `rgba(255, 255, 255, ${3 / 16})`,
  zIndex: [
    0,
    4,
    16,
    32,
    64,
  ],
  colors: {
    ...defaultColors,
    ...colors,
  },
  inverted: '#222222',
  scale: [
    0, 10, 20, 40, 80,
  ],
  fontSizes,
  monospace,
  pureRender: true,

  Card: {
    backgroundColor: '#222222',
    border: 0,
  },
  Panel: {
    borderWidth: 2,
    backgroundColor: '#000000',
  },
  NavItem: {
    fontSize: 12,
    color: '#ffbb33',
    ...caps,
  },
  Heading: {
    ...caps,
  },
  Button: {
    ...caps,
    fontSize: 12,
    color: '#ffbb33',
    opacity: 7 / 8,
  },
  ButtonOutline: {
    ...caps,
    fontSize: 12,
    color: '#ffbb33',
    opacity: 7 / 8,
  },
  Toolbar: {
    minHeight: 64,
    color: '#ffbb33',
    backgroundColor: `rgba(0, 0, 0, ${7 / 8})`,
  },
  Label: {
    opacity: 5 / 8,
  },
  Menu: {
    color: '#ffbb33',
    backgroundColor: '#000',
  },
  Message: {
    color: '#111111',
    opacity: 15 / 16,
  },
  Text: {
    opacity: 7 / 8,
  },
  Footer: {
    opacity: 1 / 2,
  },
};

export default config;
